define('AwaLabs.LoyaltyPrice', [
    'LoyaltyPrice.Helper',
    'Profile.Model',
    'LoyaltyPrice.PDP.View'
], function AwaLabsLoyaltyPrice(
    LoyaltyPriceHelper,
    Profile,
    LoyaltyPricePDPView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var pdp = container.getComponent('PDP');
            if (pdp) {
                pdp.addChildViews(
                    pdp.PDP_FULL_VIEW, {
                        'LoyaltyPricePDPView': function LoyaltyPricePDPViewFn() {
                            return new LoyaltyPricePDPView({
                                item: pdp.getItemInfo()
                            });
                        }
                    }
                );
                pdp.addChildViews(
                    pdp.PDP_QUICK_VIEW, {
                        'LoyaltyPricePDPView': function LoyaltyPricePDPViewFn() {
                            return new LoyaltyPricePDPView({
                                item: pdp.getItemInfo()
                            });
                        }
                    }
                );
            }
            if (layout) {
                layout.addToViewContextDefinition('ProductViews.Price.View', 'customContext', 'object', function fnLoyaltyPrice(context) {
                    var profile = Profile.getInstance();
                    var itemModel = (context.model && context.model.item) || context.model;
                    var customContext = LoyaltyPriceHelper.getContextForPriceView(itemModel, profile);
                    return customContext;
                });
                layout.addToViewContextDefinition('Transaction.Line.Views.Price.View', 'customContext', 'object', function fnLoyaltyPrice(context) {
                    var profile = Profile.getInstance();
                    var itemModel = (context.model && context.model.item) || context.model;
                    var customContext = LoyaltyPriceHelper.getContextForPriceView(itemModel, profile);
                    return customContext;
                });
            }
        }
    };
});
